module.exports = __webpack_public_path__ + "static/img/draw_btn.f43e809.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/draw_btn.png
// module id = 561
// module chunks = 1